if (!customElements.get('rubbie-sticky-atc')) {
  customElements.define(
    'rubbie-sticky-atc',
    class RubbieStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sticky-button]');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.button.addEventListener('click', this.onClick.bind(this));

        const target = this.mainButtons();
        if (!target) return;

        this.observer = new IntersectionObserver(([entry]) => {
          this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.observer.observe(target);

        document.addEventListener('change', (event) => {
          if (event.target.closest('product-info variant-selects')) setTimeout(() => this.sync(), 350);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.toggle(false);
      }

      mainButtons() {
        return document.querySelector('product-info .product-form__buttons');
      }

      mainSubmit() {
        return document.querySelector('product-info .product-form__submit[name="add"]');
      }

      sync() {
        const submit = this.mainSubmit();
        if (submit) {
          const text = submit.querySelector('span');
          if (text) this.label.textContent = text.textContent.trim();
          this.button.disabled = submit.disabled;
        }
        const price = document.querySelector('product-info [id^="price-"] .price');
        if (price) this.price.replaceChildren(price.cloneNode(true));
      }

      toggle(show) {
        if (show === this.visible) return;
        this.visible = show;
        if (show) this.sync();
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle(
          'rubbie-sticky-atc-visible',
          show && getComputedStyle(this).display !== 'none'
        );
      }

      onClick() {
        const submit = this.mainSubmit();
        if (submit && !submit.disabled) {
          submit.click();
          return;
        }
        const info = document.querySelector('product-info');
        if (info) info.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  );
}
